<template>
  <div class="screen-bg">
    <div class="sidebar">
      <div class="filter-box">
        <img class="logo-maranatha" src="@/assets/img/LogoMaranatha.png" />
      </div>
      <img class="bg" src="@/assets/img/FondMaranatha.jpg" />
    </div>
    <div class="bg-content">
      <slot />
    </div>
    <div class="bottom-bar"></div>
    <img class="logo-kisi" src="@/assets/img/LogoKISI.png" />
  </div>
</template>

<script>
export default {
  name: 'ScreenBg',
};
</script>

<style lang="scss">
.screen-bg {
  height: 100%;
  width: 100%;
}

$bottom-bar-height: 7.5%; //16.409%;

.sidebar {
  position: relative;
  height: 100%;
  width: $sidebar-width;

  .filter-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    height: 31.115%;
    width: 100%;
    background: rgba(239, 65, 54, 0.51);

    .logo-maranatha {
      height: 70%;
      width: auto;
    }
  }

  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $bottom-bar-height;
  background: rgba($year-color, 0.51);
}

.logo-kisi {
  position: fixed;
  left: $sidebar-width / 1.2;
  bottom: $bottom-bar-height / 1.2;
  height: 23%;
  width: auto;
}

.bg-content {
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw - $sidebar-width;
  height: 100% - $bottom-bar-height;
}

@media (max-aspect-ratio: #{$sidebar-alt-max-ratio}) {
  .logo-kisi {
    left: $sidebar-alt-width / 1.2;
  }
  .sidebar {
    width: $sidebar-alt-width;
  }
  .bg-content {
    width: calc(100% - #{$sidebar-alt-width});
  }
}
</style>
